import React from "react";
import ContactSection from "../components/contact/ContactSection";

const Contact = () => {
    return (
        <div>
            <ContactSection />
        </div>
    );
};

export default Contact;
